import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/Footer.css";
import washing_machine_logo from "../assets2/washing_machine_logo.png";

const Footer = () => {
  const location = useLocation();
  const isWashingMachinePage = location.pathname === "/washing-machine-service";

  // Dynamic configurations based on current route
  const currentPhoneNumber = isWashingMachinePage ? "73175 96984" : "72378 98275";
  const rawPhoneNumber = isWashingMachinePage ? "7317596984" : "7237898275";
  
  // Kept exactly the same as per instructions
  const currentEmail = "info@jayambeacservice.com"; 
    
  const currentBusinessName = isWashingMachinePage 
    ? "Jay Ambe Washing Machine Services" 
    : "Jay Ambe AC Service";

  const servicesList = [
    { title: "AC Service", to: "/service" },
    { title: "AC Repair", to: "/acrepair" },
    { title: "AC Installation", to: "/acinstallation" },
    { title: "AC Uninstallation Service", to: "/acunstill" },
    { title: "AC Gas Refill Service", to: "/acgais" },
    { title: "AC Annual Maintenance Service", to: "/acmaintain" },
    { title: "Split AC Repair and Service", to: "/splitac" },
    { title: "Window AC Repair and Service", to: "/windos" },
    { title: "Cassette AC Repair And Service", to: "/cassetteAC" },
  ];

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-inner">
          <div className="footer-col footer-about">
            {/* Logo renders only on washing machine page */}
            {isWashingMachinePage && (
              <div className="footer-logo">
                <img src={washing_machine_logo} alt="Washing Machine Repair" className="footer-logo-img" />
              </div>
            )}
            
            {/* Heading and paragraph adjust dynamically */}
            <h3>{isWashingMachinePage ? "About Washing Machine Repair" : "About Jay Ambe AC Service"}</h3>
            <p>
              {isWashingMachinePage 
                ? "We are trusted experts in washing machine repair, offering fast, reliable, and affordable solutions for all brands and models. Our certified technicians provide doorstep service with genuine parts and support."
                : "Jay Ambe AC Service is a leading provider of professional air conditioning installation, repair, and maintenance services in Surat. We deliver fast, reliable support to keep your space cool and comfortable year-round."
              }
            </p>
          </div>

          <div className="footer-col footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/washing-machine-service" className="footer-link">Washing Machine Service</Link></li>
              <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-services" aria-label="Our services">
            <h3>Services</h3>
            <ul>
              {servicesList.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} className="footer-link">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col footer-contact">
            <h3>Contact us</h3>
            <p>
              Phone:{" "}
              <a className="footer-link" href={`tel:${rawPhoneNumber}`} aria-label={`Call ${currentBusinessName}`}>
                {currentPhoneNumber}
              </a>
            </p>
            <p>
              Email:{" "}
              <a className="footer-link" href={`mailto:${currentEmail}`} aria-label={`Email ${currentBusinessName}`}>
                {currentEmail}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>Copyright © 2025 {currentBusinessName}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;